<template>
	<div>
		<cTable ref="table" :config="config" :fields="fields" :footer="{show:()=>false}"></cTable>
	</div>
</template>

<script>
	import cTable from "@/base/common/index";
	export default {
		components: {
			cTable
		},
		props:{
			read:{
				type:Boolean,
				default:false
			},
			list:{
				type:Array,
				default:()=>[]
			},
			row:{
				type:Object,
				default:()=>({})
			}
		},
		mounted(){
			
			setTimeout(()=>{
				this.$nextTick(()=>{
					if(this.$refs['table'])this.$refs['table'].list = this.list
				})
			},1000)
		},
		data() {
			return {
				config:{
					slot:'div',
					height:160,
					resize:false
				},
				fields:[
					{
						name: () => this.$t('packingNum'),
						placeholder:()=>this.$t("packingNum"),
						key: "case_no",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => this.$t('case_number'),
						placeholder:()=>this.$t("case_number"),
						key: "case_num",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => this.$t(`Old ${this.row.service_name || 'FBA'} Number`),
						placeholder:()=>this.$t(`Old ${this.row.service_name || 'FBA'} Number`),
						key: "old_fba",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => this.$t(`New ${this.row.service_name || 'FBA'} Number`),
						placeholder:()=>this.$t(`New ${this.row.service_name || 'FBA'} Number`),
						key: "new_fba",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => this.$t('Old SKU'),
						placeholder:()=>this.$t("Old SKU"),
						key: "old_sku",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => this.$t('New SKU'),
						placeholder:()=>this.$t("New SKU"),
						key: "new_sku",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => 'Sku '+this.$t("noofpieces"),
						placeholder:()=>'Sku '+this.$t("noofpieces"),
						key: "sku_num",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
						name: () => this.$t('Remarks'),
						placeholder:()=>this.$t("Remarks"),
						key: "remarks",
						minWidth: 130,
						component:()=>!this.read&&'Input'
					},
					{
					  type: "btns",
					  width: 160,
					  name: () => this.$t("operation"),
					  fixed: "right",
					  show:()=>{
					  	return !this.read
					  },
					  // width({ field }) {
					  //   return field.list.length * 40 + 40;
					  // },
					  list: [
					    {
					      name: () => this.$t("add"),
					      type: "add",
					      fnName: "add",
					      bind: {
					        type: "warning",
					      },
					      icon: "md-add",
								show:()=>{
									return !this.read
								},
					    },
					    {
					      name: () => this.$t("delete"),
					      type: "delete",
					      fnName: "delete",
					      icon: "md-trash",
								show:()=>{
									return !this.read
								},
					    },
					  ],
					  methods: {
					    add({ row,rowIndex }) {
								this.list.splice(rowIndex,0,{
								  boxes_number:'',
								  sku_number:'',
								})
					    },
					    delete({ row,rowIndex }) {
								this.list.splice(rowIndex,1)
								if(!this.list.length)this.list.push({
									boxes_number:'',
									sku_number:'',
								})
					    },
					  },
					},
				]
			}
		},
	}
</script>

<style scoped>

</style>